import Command from '@ckeditor/ckeditor5-core/src/command';
import Position from '@ckeditor/ckeditor5-engine/src/model/position';
import TreeWalker from '@ckeditor/ckeditor5-engine/src/model/treewalker';

export class AIFillResolvedCommand extends Command {
  refresh(): void {
    const { model } = this.editor;
    const { selection } = model.document;
    const allowedIn = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      'aiFillResolved',
    );

    this.isEnabled = allowedIn !== null;
  }

  execute({ appId, uniqueId, content }) {
    const { editor } = this;

    editor.model.change((writer) => {
      const rootBeginning = new Position(editor.model.document.getRoot(), [0]);
      const iterator = new TreeWalker({ startPosition: rootBeginning });

      [...iterator].forEach((value) => {
        if (
          value.item.name === 'aiFillResolving' &&
          value.item.getAttribute('appId') === appId.toString() &&
          value.item.getAttribute('uniqueId') === uniqueId
        ) {
          const viewFragment = editor.data.processor.toView(content);
          const modelFragment = editor.data.toModel(viewFragment);
          const insertPosition = writer.createPositionAt(value.item, 'before');

          editor.model.insertContent(modelFragment, insertPosition);
          writer.remove(value.item);

          // const aiFillElement = writer.createElement('aiFillResolved', {
          //   appId,
          //   uniqueId,
          // });

          // writer.remove(value.item);
          // editor.model.insertContent(aiFillElement, insertPosition);
          editor.focus();
        }
      });
    });
  }
}
